import { observer } from 'mobx-react';
import { ExperienceDictionaryEntryResponse } from '../../../../../../ExperiencesDictionary/Types';
import { emptyFragment } from '@execonline-inc/execonline-ui';
import usePrimaryCompetenciesStore from '../../../../../PrimaryCompetencies/PrimaryCompetenciesStore/UsePrimaryCompetenciesStore';
import { fromEmpty } from 'maybeasy';
import CompetenciesSection from '../../../../../../../Native/AEP/Common/PopoverProgramExperience/ExperienceCompetencies/CompetenciesSection';
import CompetencyItems from './CompetencyItems';

interface Props {
  experience: ExperienceDictionaryEntryResponse;
}

function Competencies({ experience }: Props) {
  const { primaryCompetencies } = usePrimaryCompetenciesStore(experience.payload);

  switch (experience.payload.offeringType) {
    case 'aep':
    case 'epc':
    case 'msuite':
      return fromEmpty(primaryCompetencies)
        .map((competencies) => (
          <CompetenciesSection>
            <CompetencyItems competencies={competencies} />
          </CompetenciesSection>
        ))
        .getOrElse(emptyFragment);
    case 'coaching':
    case 'group-coaching':
    case 'program-sequence':
      //TODO: need product details?
      // return <ExperienceProductDetails experienceResource={experienceResource} />;
      return <></>;
  }
}

export default observer(Competencies);
